import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0ec22416"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "menu"
};
const _hoisted_2 = {
  class: "content"
};
const _hoisted_3 = {
  class: "box"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "密码安全", -1));
const _hoisted_5 = {
  class: "card"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "name"
}, "用户名", -1));
const _hoisted_7 = {
  style: {
    "padding": "15px 25px 10px 10px"
  }
};
const _hoisted_8 = {
  class: "card"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "name"
}, "密码", -1));
const _hoisted_10 = {
  style: {
    "padding": "15px 25px 10px 10px"
  }
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "tishi"
}, "密码留空，表示不修改密码", -1));
const _hoisted_12 = {
  class: "card"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "name"
}, "确认密码", -1));
const _hoisted_14 = {
  style: {
    "padding": "15px 25px 10px 10px"
  }
};
const _hoisted_15 = {
  class: "card"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "name"
}, "保存", -1));
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "tishi",
  style: {
    "padding": "10px 15px"
  }
}, "请确定您对所有选项所做的更改", -1));
const _hoisted_18 = {
  class: "btn"
};
import { showFailToast, showSuccessToast } from "vant";
import { reactive, onMounted } from 'vue';
import Menu from "@/components/menu.vue";
import api from "@/api";
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const data = reactive({
      userId: '',
      account: '',
      pwd: '',
      pwds: ''
    });
    onMounted(async () => {
      var _JSON$parse, _JSON$parse2;
      const User = window.localStorage.getItem('user');
      data.userId = (_JSON$parse = JSON.parse(User)) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.id;
      data.account = (_JSON$parse2 = JSON.parse(User)) === null || _JSON$parse2 === void 0 ? void 0 : _JSON$parse2.account;
    });
    const renew = async () => {
      await api.modifyPwd(data.userId, data.pwd).then(res => {
        if (res.data.code == 0) {
          showSuccessToast(res.data.data);
          data.pwd = '';
          data.pwds = '';
        } else {
          showFailToast(res.data.msg);
        }
      });
    };
    return (_ctx, _cache) => {
      const _component_van_button = _resolveComponent("van-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(Menu, {
        "active-name": ""
      }), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("div", _hoisted_7, [_withDirectives(_createElementVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => data.account = $event),
        disabled: ""
      }, null, 512), [[_vModelText, data.account]])])]), _createElementVNode("div", _hoisted_8, [_hoisted_9, _createElementVNode("div", _hoisted_10, [_withDirectives(_createElementVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => data.pwd = $event),
        placeholder: "请输入修改的密码"
      }, null, 512), [[_vModelText, data.pwd]]), _hoisted_11])]), _createElementVNode("div", _hoisted_12, [_hoisted_13, _createElementVNode("div", _hoisted_14, [_withDirectives(_createElementVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => data.pwds = $event),
        placeholder: "请再次输入密码"
      }, null, 512), [[_vModelText, data.pwds]])])]), _createElementVNode("div", _hoisted_15, [_hoisted_16, _createElementVNode("div", null, [_hoisted_17, _createElementVNode("div", _hoisted_18, [_createVNode(_component_van_button, {
        onClick: renew,
        class: "order",
        disabled: !data.pwd || !data.pwds
      }, {
        default: _withCtx(() => [_createTextVNode("更新")]),
        _: 1
      }, 8, ["disabled"])])])])])])]);
    };
  }
});